import React from 'react';
import {Link} from 'react-router-dom';

const Notfound = () =>
    (<div>
      <h1>Not found</h1>
      <Link to="/">Go Back</Link>
    </div>);
export default Notfound;